import _ from 'lodash';

import './styles.css';
import template from './template.html';
import { addContact } from '../../core/contacts';
import * as navActions from '../../core/state-history';

export default {
  template,
  controller,
};

controller.$inject = [
  '$ngRedux',
  '$state',
  '$mdToast',
  '$translate',
];

function controller(
  $ngRedux,
  $state,
  $mdToast,
  $translate,
) {
  const EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
  let unsubscribe;

  /**
     *
     */
  this.$onInit = () => {
    unsubscribe = $ngRedux.connect((state) => ({ screenSize: state.screenSize }))((state) => {
      this.screenSize = state.screenSize;
    });

    // handle adding contact from different states
    // call details
    if ($state.params && $state.params.type) {
      this.contact = {
        email: [''],
        [`${$state.params.type}_phone`]: $state.params.number,
      };
    } else {
      this.contact = {
        email: [''],
      };
    }
  };

  /**
     *
     */
  this.$onDestroy = () => {
    unsubscribe();
  };

  /**
     *
     * @param index
     * @param error
     */
  this.emailInput = (index, error) => {
    if (!error.email) {
      if (this.contact.email[index] && (index + 1) === this.contact.email.length) {
        this.contact.email.push('');
      } else if (!this.contact.email[index]) {
        const temp = _.chain(this.contact.email)
          .compact()
          .filter((value) => EMAIL_REGEXP.test(value))
          .value();
        temp.push('');
        this.contact.email = temp;
      }
    }
  };

  /**
     *
     */
  this.navBack = () => {
    $ngRedux.dispatch(navActions.navStackBack());
    const lastOnStack = navActions.getLastOnStack($ngRedux.getState(), 'navStack');
    $state.go(lastOnStack.name, lastOnStack.params);
  };

  /**
     *
     * @param $event
     * @param valid
     */
  this.saveContact = ($event, valid) => {
    $event.preventDefault();
    if (valid) {
      $mdToast.show(
        $mdToast.simple()
          .textContent($translate.instant('CONTACT_SAVED!'))
          .position('bottom left')
          .hideDelay(1500),
      );
      $ngRedux.dispatch(addContact(this.contact));
      this.navBack();
    }
  };
}
